export const COMPLAINT_DIALOG_TEXT = {
	de: `Um Ihr Anliegen zu klären, möchten wir Sie bitten die nächsten Schritte zu befolgen.
    
    Wir bitten Sie um:
    - Das Hochladen neuer Scans/Modelle ohne Retainer
    - Das Hochladen eines Fotos der Beanstandung (Bruch, Passung …)
    - Eine Beschreibung des detaillierten Sachverhalts
    
    Möchten Sie Modelle senden, bitten wir Sie eine UPS-Beauftragung telefonisch bei uns anzufragen.
    
    Bitte beachten Sie, dass eine erneute Inanspruchnahme der Garantie anhand alter Daten entfällt.
    
    Wir bitten um Ihr Verständnis und sind gerne bereit, Ihnen bei weiteren Fragen und Anliegen behilflich zu sein.`,

	en: `In order to clarify your concern, we would like to ask you to follow the next steps.
    
    Please provide us:
    - An upload of new scans/models without retainers
    - An upload of a photo of the complaint (breakage, fit, etc.)
    - A detailled description of the issue
    
    If you would like to send models, please call us to request a UPS order.
    
    Please note that the warranty does not need to be claimed again based on old data.
    
    We ask for your understanding and are happy to help you with any further questions or concerns.`
};
